import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminanalisis',
  templateUrl: './adminanalisis.component.html',
  styleUrls: ['./adminanalisis.component.scss']
})
export class AdminanalisisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
